
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { ISupportCategory } from "./SupportCategoryService";
import { HeraBaseService, ISupportPlatform } from "./HeraBaseService";

export interface ISupportArticle {
    title: string;
    content: string;
    helpful: number;
    language: string;
    external_id: string;
    not_helpful: number;
    category_id: string;
    platform_id: string;
    category: ISupportCategory;
    platform: ISupportPlatform;
}

export class SupportArticleService extends HeraBaseService {

    protected static instance: SupportArticleService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportArticleService.instance) SupportArticleService.instance = new SupportArticleService();
        return SupportArticleService.instance;
    }

    querySupportArticles(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ISupportArticle>> {
        params["platform.platform_id"] = params.platform_id;
        delete params.platform_id;
        return this.report(this.transport.get("/hera/api/v1/support/article", { query: this.normalizeParams(params) }));
    }

    createSupportArticle(supportArticle: Partial<ISupportArticle>): Promise<SanitizedResponse<ISupportArticle>> {
        return this.report(this.transport.post("/hera/api/v1/support/article", supportArticle));
    }

    updateSupportArticle(supportArticle: Partial<ISupportArticle>): Promise<SanitizedResponse<ISupportArticle>> {
        return this.report(this.transport.patch(`/hera/api/v1/support/article/${supportArticle.external_id}`, supportArticle));
    }

    deleteSupportArticle(id: string): Promise<SanitizedResponse<ISupportArticle>> {
        return this.report(this.transport.delete(`/hera/api/v1/support/article/${id}`));
    }

}

